import axiosInstance from '../api.service.js';
import constants from '../../constants/constants';
import axios from 'axios';

const ENDPOINTORIGIN = "JobForm/";

const getJobForms = async (jobId) => await axiosInstance.get(ENDPOINTORIGIN + 'GetJobForms?jobId=' + jobId, constants.REQUIRE_INTERCEPTORS);

const getAsNeededForms = async (jobId) => await axiosInstance.get(ENDPOINTORIGIN + 'GetAsNeededForms?jobId=' + jobId, constants.REQUIRE_INTERCEPTORS);

const getUploadFormId = async (jobFormId) => await axiosInstance.get(ENDPOINTORIGIN + 'GetUploadFormId?jobFormId=' + jobFormId, constants.REQUIRE_INTERCEPTORS);

const submitForm = async (jobFormId) => await axiosInstance.post(ENDPOINTORIGIN + 'SubmitForm?jobFormId=' + jobFormId, {}, constants.REQUIRE_INTERCEPTORS);

const unsubmitForm = async (jobFormId) => await axiosInstance.post(ENDPOINTORIGIN + 'UnSubmitForm?jobFormId=' + jobFormId, {}, constants.REQUIRE_INTERCEPTORS);

const getProposalProjectLocationsByJobFormId = async (jobFormId) => await axiosInstance.get(ENDPOINTORIGIN + 'GetProposalProjectLocationsByJobFormId?jobFormId=' + jobFormId, constants.REQUIRE_INTERCEPTORS);

export {
    getJobForms,
    unsubmitForm,
    getAsNeededForms,
    getUploadFormId,
    submitForm,
    getProposalProjectLocationsByJobFormId
}